import {useCallback} from 'react';
import {call} from 'redux-saga/effects';

import {actionEffects as actions} from "../store/actions";
import {defaultSettings} from "../store/settings";
import {useSagaCallback} from "../utils/sagas";
import {apiPost, clearApiCredentials} from "./client";

const useLogout = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* () {
        try {
            yield call(apiPost, `/api/v2/logout`);
        } catch (error) {
            // If the server responds with "invalid credentials", we consider the session to
            // have been cleared outside the app, and proceed with logging the user out locally.
            if (error.message !== "invalid credentials") {
                throw error;
            }
        }
        yield call(clearApiCredentials);
        yield actions.settingsChanged(defaultSettings);
        yield actions.userChanged();
    }, []));
};

export default useLogout;
